import { useEffect } from 'react'
import { catchFocusAtom } from '~/states'
import { useAtom } from 'jotai'

export const useBXWidgetControl = () => {
  const [, setCatchFocus] = useAtom(catchFocusAtom)
  const widgetControl = event => {
    const widget = event.detail.widget
    widget.subscribe({
      type: BX.LiveChatWidget.SubscriptionType.widgetOpen,
      callback: () => {
        setCatchFocus(false)
      },
    })
    widget.subscribe({
      type: BX.LiveChatWidget.SubscriptionType.widgetClose,
      callback: () => {
        setCatchFocus(true)
      },
    })
    widget.mutateTemplateComponent('bx-livechat-form-welcome', {
      template: '<div></div>',
    })
  }

  //TODO: Bitrix Widget ReactWrapper
  useEffect(() => {
    window.addEventListener('onBitrixLiveChat', widgetControl)
    return () => removeEventListener('onBitrixLiveChat', widgetControl)
  }, [])
  return null
}
